
import "@sparta.falcon.modules/software-details-with-images-module/dist/styles.css"


import secureLinkUtility from "@sparta.sales.utilities/secure-link-utility/dist/es5.js"
import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es5.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es5.js"

import "@sparta.common.modules/mbox-module/dist/es5.js"
import "@sparta.falcon.modules/software-details-with-images-module/dist/es5.js"
import "@sparta.falcon.modules/software-details-with-images-module/dist/es5.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  var bootExecs = [];
  bootExecs.push(function() { return spartaBootstrapUtility.init(arguments); });
  bootExecs.push(function() { return secureLinkUtility.run() });
  bootExecs.reduce(function(cur, next) {
    return cur.then(next);
  }, Promise.resolve()).then(function() {
    console.log('after - execute boot functions')
  });
})();
